import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { getProductStockReport } from "../../../actions/report";
import { getAllTransferLocation } from "../../../actions/warehouseAction";
import { getAllTag } from "../../../actions/Inventory/tagAction";
import {
    Divider,
    AutoComplete,
    Row,
    Col,
    Select,
    Skeleton,
    Button,
    DatePicker,
    Table,
    Breadcrumb,
} from "antd";
import moment from "moment";

const { Option } = Select;
const { RangePicker } = DatePicker;

const StockSummaryReport = ({
    getProductStockReport,
    getAllTransferLocation,
    getAllTag,
}) => {
    const [List, setList] = useState({ results: [], count: 0 });
    const [locations, setLocations] = useState([]);
    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [reload, setReload] = useState(false);

    const filters = useRef({
        start_date: "",
        end_date: "",
        office: "",
        tag: "",
        keyword: "",
        page: 1,
        page_size: 100,
    });

    useEffect(() => {
        getAllTransferLocation().then((result) => {
            setLocations(result);
        });
        getAllTag().then((result) => {
            setTags(result);
        });
        fetchReport();
    }, [reload]);

    const fetchReport = () => {
        setLoading(true);
        getProductStockReport(filters.current).then((result) => {
            if (result) {
                setList(result);
            }
            setLoading(false);
        });
    };

    const onChange = (e) => {
        filters.current.keyword = e.target.value;
    };

    const onSearch = () => {
        filters.current.page = 1;
        setReload(!reload);
    };

    const onDateChange = (dates, dateStrings) => {
        filters.current.start_date = dateStrings[0];
        filters.current.end_date = dateStrings[1];
        filters.current.page = 1;
        setReload(!reload);
    };

    const onLocationChange = (value) => {
        filters.current.office = value;
        filters.current.page = 1;
        setReload(!reload);
    };

    const onTagChange = (value) => {
        filters.current.tag = value;
        filters.current.page = 1;
        setReload(!reload);
    };


    const handleTableChange = (pagination) => {
        filters.current.page = pagination.current;
        filters.current.page_size = pagination.pageSize;
        setReload(!reload);
    };

    const expandedRowRender = (record) => {
        const purchaseColumns = [
            { title: 'Attributes', dataIndex: 'attributes', key: 'attributes' },
            { title: 'Purchase Qty', dataIndex: 'quantity', key: 'quantity' },
        ];

        const entryColumns = [
            { title: 'Attributes', dataIndex: 'attributes', key: 'attributes' },
            { title: 'Warehouse', dataIndex: 'warehouse', key: 'warehouse' },
            { title: 'Batch No', dataIndex: 'batch_no', key: 'batch_no' },
            { title: 'Entry Qty', dataIndex: 'quantity', key: 'quantity' },
        ];

        const stockColumns = [
            { title: 'Attributes', dataIndex: 'attributes', key: 'attributes' },
            { title: 'Warehouse', dataIndex: 'warehouse', key: 'warehouse' },
            { title: 'Batch No', dataIndex: 'batch_no', key: 'batch_no' },
            { title: 'Stock Qty', dataIndex: 'quantity', key: 'quantity' },
        ];

        const invoiceColumns = [
            { title: 'Attributes', dataIndex: 'attributes', key: 'attributes' },
            { title: 'Warehouse', dataIndex: 'warehouse', key: 'warehouse' },
            { title: 'Batch No', dataIndex: 'batch_no', key: 'batch_no' },
            { title: 'Invoice Qty', dataIndex: 'quantity', key: 'quantity' },
        ];

        const totalPurchaseQty = (record.purchase_items && record.purchase_items.length > 0)
            ? record.purchase_items.reduce((sum, item) => sum + (item.quantity || 0), 0)
            : 0;

        const totalEntryQty = (record.location_entries && record.location_entries.length > 0)
            ? record.location_entries.reduce((sum, item) => sum + (item.quantity || 0), 0)
            : 0;

        const totalStockQty = (record.stock_breakdown && record.stock_breakdown.length > 0)
            ? record.stock_breakdown.reduce((sum, item) => sum + (item.quantity || 0), 0)
            : 0;

        const totalInvoiceQty = (record.invoice_items && record.invoice_items.length > 0)
            ? record.invoice_items.reduce((sum, item) => sum + (item.quantity || 0), 0)
            : 0;

        return (
            <div style={{ padding: '10px', background: '#f5f5f5', borderRadius: '8px' }}>
                <Row gutter={16}>
                    <Col span={6}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <h4 style={{ margin: 0 }}>Purchase Breakdown</h4>
                            <span style={{ fontWeight: 'bold' }}>
                                Total: {totalPurchaseQty}
                            </span>
                        </div>
                        <Table
                            columns={purchaseColumns}
                            dataSource={record.purchase_items}
                            pagination={false}
                            size="small"
                            rowKey="attributes"
                            bordered
                            summary={(pageData) => {
                                let totalQty = 0;
                                if (pageData) {
                                    pageData.forEach(({ quantity }) => {
                                        totalQty += (quantity || 0);
                                    });
                                }
                                return (
                                    <Table.Summary fixed>
                                        <Table.Summary.Row style={{ background: '#fafafa' }}>
                                            <Table.Summary.Cell index={0}><strong>Total</strong></Table.Summary.Cell>
                                            <Table.Summary.Cell index={1}>
                                                <strong>{totalQty}</strong>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                );
                            }}
                        />
                    </Col>
                    <Col span={6}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <h4 style={{ margin: 0 }}>Stock Entry Breakdown</h4>
                            <span style={{ fontWeight: 'bold' }}>
                                Total: {totalEntryQty}
                            </span>
                        </div>
                        <Table
                            columns={entryColumns}
                            dataSource={record.location_entries}
                            pagination={false}
                            size="small"
                            rowKey={(rec) => (rec && rec.attributes && rec.warehouse) ? `${rec.attributes}-${rec.warehouse}` : Math.random()}
                            bordered
                            summary={(pageData) => {
                                let totalQty = 0;
                                if (pageData) {
                                    pageData.forEach(({ quantity }) => {
                                        totalQty += (quantity || 0);
                                    });
                                }
                                return (
                                    <Table.Summary fixed>
                                        <Table.Summary.Row style={{ background: '#fafafa' }}>
                                            <Table.Summary.Cell index={0} colSpan={3}><strong>Total</strong></Table.Summary.Cell>
                                            <Table.Summary.Cell index={3}>
                                                <strong>{totalQty}</strong>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                );
                            }}
                        />
                    </Col>
                    <Col span={6}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <h4 style={{ margin: 0 }}>Current Stock Breakdown</h4>
                            <span style={{ fontWeight: 'bold' }}>
                                Total: {totalStockQty}
                            </span>
                        </div>
                        <Table
                            columns={stockColumns}
                            dataSource={record.stock_breakdown}
                            pagination={false}
                            size="small"
                            rowKey={(rec) => (rec && rec.attributes && rec.warehouse) ? `stock-${rec.attributes}-${rec.warehouse}` : Math.random()}
                            bordered
                            summary={(pageData) => {
                                let totalQty = 0;
                                if (pageData) {
                                    pageData.forEach(({ quantity }) => {
                                        totalQty += (quantity || 0);
                                    });
                                }
                                return (
                                    <Table.Summary fixed>
                                        <Table.Summary.Row style={{ background: '#fafafa' }}>
                                            <Table.Summary.Cell index={0} colSpan={3}><strong>Total</strong></Table.Summary.Cell>
                                            <Table.Summary.Cell index={3}>
                                                <strong>{totalQty}</strong>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                );
                            }}
                        />
                    </Col>
                    <Col span={6}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                            <h4 style={{ margin: 0 }}>Invoice Breakdown</h4>
                            <span style={{ fontWeight: 'bold' }}>
                                Total: {totalInvoiceQty}
                            </span>
                        </div>
                        <Table
                            columns={invoiceColumns}
                            dataSource={record.invoice_items}
                            pagination={false}
                            size="small"
                            rowKey={(rec) => (rec && rec.attributes && rec.warehouse) ? `invoice-${rec.attributes}-${rec.warehouse}` : Math.random()}
                            bordered
                            summary={(pageData) => {
                                let totalQty = 0;
                                if (pageData) {
                                    pageData.forEach(({ quantity }) => {
                                        totalQty += (quantity || 0);
                                    });
                                }
                                return (
                                    <Table.Summary fixed>
                                        <Table.Summary.Row style={{ background: '#fafafa' }}>
                                            <Table.Summary.Cell index={0} colSpan={3}><strong>Total</strong></Table.Summary.Cell>
                                            <Table.Summary.Cell index={3}>
                                                <strong>{totalQty}</strong>
                                            </Table.Summary.Cell>
                                        </Table.Summary.Row>
                                    </Table.Summary>
                                );
                            }}
                        />
                    </Col>
                </Row>
            </div>
        );
    };

    const columns = [
        {
            title: "SL",
            width: 60,
            render: (text, record, index) => (filters.current.page - 1) * filters.current.page_size + index + 1
        },
        // { title: "Product Title", dataIndex: "product_title", key: "product_title" },
        { title: "Product Code", dataIndex: "product_code", key: "product_code" },

        {
            title: "Purchase Qty",
            key: "total_purchase_qty",
            align: "center",
            render: (record) => {
                const total = (record.purchase_items && record.purchase_items.length > 0)
                    ? record.purchase_items.reduce((sum, item) => sum + (item.quantity || 0), 0)
                    : 0;
                return <span style={{ fontWeight: "bold" }}>{total}</span>;
            }
        },
        {
            title: "Entry Qty",
            key: "total_entry_qty",
            align: "center",
            render: (record) => {
                const total = (record.location_entries && record.location_entries.length > 0)
                    ? record.location_entries.reduce((sum, item) => sum + (item.quantity || 0), 0)
                    : 0;
                return <span style={{ fontWeight: "bold" }}>{total}</span>;
            }
        },
        {
            title: "Current Stock",
            key: "current_stock",
            align: "center",
            render: (record) => {
                const total = (record.stock_breakdown && record.stock_breakdown.length > 0)
                    ? record.stock_breakdown.reduce((sum, item) => sum + (item.quantity || 0), 0)
                    : 0;
                return <span style={{ fontWeight: "bold", color: "#1890ff" }}>{total}</span>;
            }
        },
        {
            title: "Invoice Qty",
            key: "total_invoice_qty",
            align: "center",
            render: (record) => {
                const total = (record.invoice_items && record.invoice_items.length > 0)
                    ? record.invoice_items.reduce((sum, item) => sum + (item.quantity || 0), 0)
                    : 0;
                return <span style={{ fontWeight: "bold" }}>{total}</span>;
            }
        },
        {
            title: "Verified",
            key: "verified",
            align: "center",
            render: (record) => {
                const purchaseQty = (record.purchase_items && record.purchase_items.length > 0)
                    ? record.purchase_items.reduce((sum, item) => sum + (item.quantity || 0), 0)
                    : 0;
                const currentStock = (record.stock_breakdown && record.stock_breakdown.length > 0)
                    ? record.stock_breakdown.reduce((sum, item) => sum + (item.quantity || 0), 0)
                    : 0;
                const invoiceQty = (record.invoice_items && record.invoice_items.length > 0)
                    ? record.invoice_items.reduce((sum, item) => sum + (item.quantity || 0), 0)
                    : 0;

                const isMatched = (currentStock + invoiceQty) === purchaseQty;

                return (
                    <span style={{
                        color: isMatched ? "#52c41a" : "#ff4d4f",
                        fontWeight: "bold",
                        textTransform: "uppercase"
                    }}>
                        {isMatched ? "ok" : "missing"}
                    </span>
                );
            }
        },
    ];

    return (
        <>
            <Breadcrumb style={{ margin: "16px 0" }}>
                <Breadcrumb.Item>Report</Breadcrumb.Item>
                <Breadcrumb.Item>Stock Summary Report</Breadcrumb.Item>
            </Breadcrumb>
            <div className="site-layout-background main-frame" style={{ padding: 24 }}>
                <Row gutter={16} align="bottom" style={{ marginBottom: 20 }}>
                    <Col span={6}>
                        <span>Keyword Search:</span>
                        <AutoComplete
                            placeholder="Title or code..."
                            onChange={(value) => filters.current.keyword = value}
                            onSelect={onSearch}
                            style={{ width: "100%", display: "block", marginTop: 5 }}
                        />
                    </Col>
                    <Col span={5}>
                        <span>Date Range:</span>
                        <RangePicker onChange={onDateChange} style={{ width: "100%", marginTop: 5 }} />
                    </Col>
                    <Col span={5}>
                        <span>Warehouse:</span>
                        <Select
                            placeholder="Select Warehouse"
                            style={{ width: "100%", marginTop: 5 }}
                            onChange={onLocationChange}
                            defaultValue=""
                        >
                            <Option value="">All Locations</Option>
                            {locations.map((loc) => (
                                <Option key={loc.id} value={loc.id}>{loc.name}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <span>Tag:</span>
                        <Select
                            placeholder="Select Tag"
                            style={{ width: "100%", marginTop: 5 }}
                            onChange={onTagChange}
                            defaultValue=""
                        >
                            <Option value="">All Tags</Option>
                            {tags && tags.length > 0 && tags.map((tag) => (
                                <Option key={tag.id} value={tag.id}>{tag.name}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col span={2}>
                        <Button type="primary" onClick={onSearch} style={{ width: "100%" }}>Search</Button>
                    </Col>
                </Row>
                <Divider />
                <Table
                    dataSource={List.results}
                    columns={columns}
                    loading={loading}
                    expandable={{ expandedRowRender }}
                    pagination={{
                        current: filters.current.page,
                        pageSize: filters.current.page_size,
                        total: List.count,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100', '500']
                    }}
                    onChange={handleTableChange}
                    rowKey="id"
                    size="small"
                    bordered
                />
            </div>
        </>
    );
};

export default connect(null, { getProductStockReport, getAllTransferLocation, getAllTag })(StockSummaryReport);
